<template>
    <div ref="page">
        <div :class="['text', { show }]">
            <p v-for="(i, k) in text" :key="`${i}${k}`" v-html="i"></p>
        </div>
        <div class="imgs">
            <img
                :src="p === 'null'? nullPic : p"
                alt=""
                v-for="(p,i) in pics"
                :key="i"
                @animationend="showText(i)"
                >
        </div>
        <div :class="['download',{show}]" v-if="!$bridge.isApp" @click="download"></div>
        <div :class="['btn',{show}]" @click="share">{{$bridge.isApp? '点击分享' : '长按保存图片'}}</div>
        <template v-if="!$bridge.isApp">
            <div class="template" ref="imgTemplate">
                <div class="template-text">
                    <p v-for="(i, k) in text" :key="`${i}${k}`" v-html="i"></p>
                </div>
                <img :src="nullPic" alt="" class="zhang" v-if="!pics[pics.length-1] || pics[pics.length-1] === 'null'">
                <img :src="pics[pics.length-1]" alt="" class="zhang" v-else>
            </div>
            <img :src="base64" alt="" class="imgTemplate">
        </template>
    </div>
</template>

<script>
import html2canvas from 'html2canvas';

export default {
    data() {
        return {
            base64: '',
            show: false,
            nullPic: '/img/xj/seal-none.png',
            pics: [],
            text: [
                ['冻云宵遍岭<i></i>素雪晓凝华', '入牖千重碎<i></i>迎风一半斜', '不妆空散粉<i></i>无树独飘花', '萦空惭夕照<i></i>破彩谢晨霞', '望雪 唐代·李世民'],
                ['终南阴岭秀<i></i>积雪浮云端', '林表明霁色<i></i>城中增暮寒', '终南望余雪 唐代·祖咏']
                // ['寒更传晓箭，清镜览衰颜', '隔牖风惊竹，开门雪满山', '洒空深巷静，积素广庭闲', '借问袁安舍，翛然尚闭关', '冬晚对雪忆胡居士家 唐代·王维']
            ][Math.floor(Math.random() * 2)]
        };
    },
    methods: {
        download() {
            window.location.replace('https://www.ywbjchina.com/h5/download/default');
        },
        showText(i) {
            if (i >= Math.floor(this.pics.length / 2)) {
                this.show = true;
            }
        },
        share() {
            if (this.$bridge.isApp) {
                this.$bridge.share({
                    title: '回到宋朝去赏雪',
                    desc: '今年冬天，许你一个不一样的瑞雪兆丰年',
                    link: window.location.href,
                    imgUrl: `${window.location.origin}/img/xj/share_bg.png`
                });
            }
        }
    },
    mounted() {
        if (!this.$bridge.isApp) {
            html2canvas(this.$refs.imgTemplate, {
                scale: 1,
                logging: false,
                useCORS: true
            }).then(c => {
                this.base64 = c.toDataURL('image/png');
            });
        }
    },
    created() {
        this.pics = JSON.parse(localStorage.getItem('pics')) || [];
    }
};
</script>

<style lang="stylus" scoped>
.imgTemplate
    position absolute
    z-index 9
    size 100%
    opacity 0
.template
    position absolute
    left -100%
    size 750px 1334px
    background url('/img/xj/template.jpg') 0 0/100% 100% no-repeat
    .template-text
        position absolute
        top 1rem
        right .6rem
        height 4.1rem
        p
            width .7rem
            height 100%
            font-size .36rem
            color #fbecc3
            line-height 1.5
            float right
            writing-mode tb-rl
            text-align center
            &:last-child
                font-size .28rem
            >>> i
                display inline-block
                size .36rem .25rem
    .zhang
        position absolute
        max-width 62px
        max-height 118px
        left 49px
        bottom 70px
.text
    position absolute
    top 1rem
    right .6rem
    height 4.1rem
    opacity 0
    transition opacity 2s
    display flex
    flex-direction row-reverse
    p
        width .5rem
        margin-left .2rem
        height 100%
        font-size .36rem
        color #fbecc3
        line-height 1.5
        writing-mode tb-rl
        text-align center
        &:last-child
            font-size .28rem
        >>> i
            size .36rem .25rem
            display inline-block
    &.show
        opacity 1
.imgs
    position absolute
    height 1.2rem
    bottom 2.45rem
    right .45rem
    display flex
    align-items center
    flex-direction row-reverse
    img
        margin 0 .1rem
        max-width .62rem
        max-height 1.18rem
        filter blur(2px)
        transform scale(2)
        opacity 0
        animation endText 1s cubic-bezier(0.55, 0.085, 0.68, 0.53)
        animation-fill-mode forwards
        for i in 1 2 3 4 5 6 7 8 9 10
            &:nth-child({i})
                animation-delay ((i - 1) / 3) s
.download
    position absolute
    bottom 1rem
    left 50%
    transform translateX(-50%)
    size 2.24rem .8rem
    background url('/img/xj/btn_appdownload.png') 0 0/100% 100% no-repeat
    z-index 10
    opacity 0
    transition opacity 1s 1s
    &.show
        opacity 1
.btn
    position absolute
    bottom 0
    left 25%
    font-size .24rem
    color #fbecc2
    size 50% 1.2rem
    text-align center
    line-height 1.2rem
    opacity 0
    transition opacity 1s 1s
    &.show
        opacity 1
</style>
